import "../Menu.scss";
import { useState } from "react";
import { Link } from "react-router-dom";
import otherFeature1 from "../../../assets/menu/other/other-feature1.jpeg";
import otherFeature2 from "../../../assets/menu/other/other-feature2.jpeg";
import otherFeature3 from "../../../assets/menu/other/other-feature3.jpeg";
import otherFeature4 from "../../../assets/menu/other/other-feature4.jpeg";
import Accordion from "../../../common/Accordion";
import MenuNav from "../MenuNav";
import MenuGallery from "../MenuGallery";

function TartsBarsBrownies() {
  const [tartsOpened, setTartsOpened] = useState(false);
  const [barsOpened, setBarsOpened] = useState(false);
  const [browniesOpened, setBrowniesOpened] = useState(false);

  return (
    <div className="wrapper">
      <h1>
        <Link to="/menu" className="menu-title-link">
          Menu
        </Link>
      </h1>
      <MenuNav />

      <MenuGallery
        image1={{ src: otherFeature1, alt: "Mini fruit tarts" }}
        image2={{ src: otherFeature2, alt: "Brownies" }}
        image3={{ src: otherFeature3, alt: "Lemon bars" }}
        image4={{ src: otherFeature4, alt: "Large fruit tarts" }}
      />

      <Accordion
        className="menu-accordion"
        title="Lemon Bars"
        isOpen={barsOpened}
        onToggle={() => setBarsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All lemon bars are{" "}
            <strong>free of tree nuts</strong>.
          </p>
          <p>
            Bright, tangy, and made for true lemon lovers, lemon bars bring a
            bold citrus flavor to every bite. These are made with a gooey lemon
            filling and a buttery shortbread crust, then finished with a
            generous dusting of powdered sugar. They are a wonderful addition to
            office gatherings, parties, weddings, dessert assortments, and
            celebrations.
          </p>
          <p>Pricing: $40/dozen for mini bars, $75/dozen for full size bars</p>
        </div>
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Brownies"
        isOpen={browniesOpened}
        onToggle={() => setBrowniesOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All brownies are{" "}
            <strong>free of tree nuts</strong>.
          </p>
          <p>
            Rich, chocolatey, and irresistibly fudgy, these brownies feature a
            deep cocoa flavor, gooey center, and lightly crisp exterior. Perfect
            for dessert platters, office events, and any occasion calling for a
            classic chocolate treat.
          </p>
          <p>Pricing: $32/dozen for mini bars, $64/dozen for full size bars</p>
        </div>
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Fruit Tarts"
        isOpen={tartsOpened}
        onToggle={() => setTartsOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All fruit tarts are{" "}
            <strong>free of tree nuts</strong>.
          </p>
          <p>
            Freshly baked and beautifully finished, our tarts feature a sweet
            and buttery crust filled with vanilla custard and topped with fresh
            mixed berries or seasonal fruit. Available as individual tarts or a
            larger 9" size perfect for dessert tables, celebrations, and special
            gatherings.
          </p>
          <p>Pricing: $75/dozen for mini tarts, $150 for single 9" tart</p>
        </div>
      </Accordion>
    </div>
  );
}

export default TartsBarsBrownies;
